import wx from '@/assets/tools/WxSdk';

function oAppletEngine(engine) {
  this.engine = engine;
  this.infor = {
    //用户机型
    model: '',
    isShowPage: false,
    url: '',
    youPinName: '',
    youPinPass: '',
    lat: '',
    lng: '',
  };
  this.interfaceList = {
    // 创建充电订单，
    createChargeOrder: '/charging_pile/order/charge/create',
    // 创建充值卡订单，
    createCardOrder: '/charging_pile/order/card/recharge/create',
    // 创建充值余额订单，
    createRechargeOrder: '/charging_pile/order/recharge/create',
    // 关闭订单
    closeOrder: '/charging_pile/order/close',
    // 开始充电
    start: '/charging_pile/start',
    // 停止充电
    stop: '/charging_pile/transfer/charge/stop',
    // 微信支付
    wxPay: '/applet/wechat/wxPay',
    // 微信方法校验
    getsignal: '/charging_pile/applet/wechat/getsignal',
    // 支付
    pay: '/charging_pile/cashier/pay',
    // 充电控制
    chargeDetail: '/charging_pile/transfer/charge/refresh',
    // 悠品钱包
    YouPinDetail: '/charging_pile/cashier/youpin/getuserbalance',
    // 邮件短信报警
    sendWarnMsg: '/charging_pile/repair/push',
    //钱包退款申请
    WalletRefund: '/charging_pile/apply/account/refund',

  }
}

oAppletEngine.prototype = {
  wxMethods (method,arg) {
    return new Promise(async (resolve,reject) => {
        // 微信参数放在通过参数传入，成功和失败回调通过promise进行返回
        let appletMethods = await this.appletMethods();
        let obj = ('getLocation' in appletMethods) ? my : wx;
        // 如果obj里面有该方法 就调用该方法 如果没有就远程交互
        if (obj[method]) {
          obj[method]({
            ...arg,
            success(response){
              resolve(response)
            },
            fail(err) {
              reject(err)
            }
          })
        } else {
          this.postAppletMessage({method},res => {
            resolve(res)
          })
        }


    })
  },
  // 适配底部导航栏
  isShowAppletPadding() {
    let modelFlag = false;
    let modelList = ['iPhoneX','iPhone11','iPhone12'];
    if (this.model) {
      let tempModel = this.model.replace(/\s+/g,'');
      for (let i=0; i<modelList.length; i++) {
        if (tempModel.indexOf(modelList[i]) > -1) {
          modelFlag = true;
          break;
        }
      }
    }
    return modelFlag;
  },
  async wxReLaunch(p) {
    let appletMethods = await this.appletMethods()
    appletMethods.reLaunch({
      url: p
    });
  },
  async wxRedirectTo(p) {
    let appletMethods = await this.appletMethods()
    appletMethods.redirectTo({
      url: p
    });
  },
  async wxNavgateTo(p) {
    let appletMethods = await this.appletMethods()
    appletMethods.navigateTo({
      url: p
    });
  },
  async postAppletMessage(params,fun) {
    let appletMethods = await this.appletMethods();
    // window.history.go(-1);
    appletMethods.postMessage({
      data: params
    })
    if (window.my) {
      window.my.onMessage= function (e) {
          fun && fun(e);
      }
    }
  },
  async wxBack() {
    let appletMethods = await this.appletMethods()
    appletMethods.navigateBack()
  },
  async appletMethods() {
    if (window.my) {
      let res = await this.isAliPayApplet();
      return res ? my : '';
    } else {
      let res = await this.isWeChatApplet();
      return res ? wx.miniProgram : '';
    }
  },
  async backToRefesh(pageTo) {
    let appletMethods = await this.appletMethods();
    if ('getLocation' in appletMethods) {
      this.postAppletMessage({
          pageTo,
      });
    } else {
      this.postAppletMessage({
          pageTo,
      });
      window.history.go(-1);
      this.wxBack()
    }
  },
  //判断支付宝小程序
  isAliPayApplet() {
    return new Promise(res => {
      my.getEnv(({ miniprogram }) => {
        if (!miniprogram) {
          res(false)
        } else {
          res(true)
        }
      });
    })
  },
  appletLogout() {
    this.engine.passport.appKey = "";
    this.engine.passport.token = "";
    this.engine.passport.password = "";
    this.engine.applet.wxRedirectTo('/pages/login/index?isLogin=no');
    localStorage.removeItem('userInfo');
    this.postAppletMessage({
        pageTo: 'Main'
    });
  },
  //判断微信小程序
  isWeChatApplet() {
    return new Promise(res => {
      if (window['__wxjs_environment'] === "miniprogram") {
        res(true)
      } else {
        wx.miniProgram.getEnv(function({ miniprogram }) {
          if (!miniprogram) {
            res(false)
          } else {
            res(true)
          }
        })
      }
    })
  },
  async noLoginToPage(_) {
    if (!_.isLogin) {
      let res = await _.$dialog.confirm({
          title: '您还未登录',
          message: '请先登录再进行操作',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: '立即登录',
          cancelButtonText: '暂不登录',
          confirmButtonColor: '#000',
          cancelButtonColor: 'red'
      })
      res == 'confirm' && this.engine.applet.wxNavgateTo('/pages/login/index');
    }
    return _.isLogin;
  },
  wxConfig (debug = false,jsApiList,successCallback,failCallback) {
    window.my ? this.aliPayConfig(successCallback) : this.wxPayConfig(debug,jsApiList,successCallback,failCallback);
  },
  // 使用微信方法 必须去用wx.config的jsApiList去拿权限，然后才能使用，如果有一个页面使用，每个页面都需要调用，页面初始化调用即可。
  wxPayConfig(debug,jsApiList,successCallback,failCallback) {
    let signLink = ''
    if (/iPhone|iPad|iPod/.test(this.model)) {
      if (!this.isShowPage) {
        this.isShowPage = true;
        this.url = encodeURIComponent(location.href.split("#")[0]);
      }
      signLink = this.url;
    } else {
      signLink = encodeURIComponent(location.href.split("#")[0])
    }
    this.engine.request.api.get(this.interfaceList.getsignal + '?url='+signLink +'&access_token='+this.engine.passport.token,function(res) {
      wx.config({
        debug,
        appId: res.content.appID,
        timestamp: res.content.timestamp,
        nonceStr: res.content.nonceStr,
        signature: res.content.signature,
        jsApiList
      })
      wx.ready(successCallback)
      wx.error(failCallback)
    })
  },
  aliPayConfig(successCallback) {
    successCallback && successCallback();
  },
  //拿去充电桩使用鉴权
  chargingAjax: function(options) {
    let params = '';
    if (options.method == 'get' && options.params) {
      let type = '';
      for (let key in options.params) {
        type += `${key}=${options.params[key]}&`
      }
      params = type.slice(0,type.length - 1)
    }
    return new Promise((resolve,reject) => {
      options.method == 'get' ?
      this.engine.request.api.get(`${this.interfaceList[options.url]}?${params}`, res => resolve(res), err => reject(err)) :
      this.engine.request.api.post(this.interfaceList[options.url],options.params,res => resolve(res), err => reject(err))
    })
  },
  //计算距离
 getDisance(lat1, lng1, lat2, lng2) {
  let dis = 0;
  let radLat1 = toRad(lat1);
  let radLat2 = toRad(lat2);
  let deltaLat = radLat1 - radLat2;
  let deltaLng = toRad(lng1) - toRad(lng2);
  dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
  return dis * 6378137;
  function toRad(d) {  return d * Math.PI / 180; }
},
gcj02towgs84(lng, lat) {
  var PI = 3.1415926535897932384626;
  var a = 6378245.0; //卫星椭球坐标投影到平面地图坐标系的投影因子。
  var ee = 0.00669342162296594323; //椭球的偏心率。
    function transformlat(lng, lat) {
      var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
      return ret
  }

  function transformlng(lng, lat) {
      var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
      return ret
  }

  var dlat = transformlat(lng - 105.0, lat - 35.0);

  var dlng = transformlng(lng - 105.0, lat - 35.0);

  var radlat = lat / 180.0 * PI;

  var magic = Math.sin(radlat);

  magic = 1 - ee * magic * magic;

  var sqrtmagic = Math.sqrt(magic);

  dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);

  dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);

  var mglat = lat + dlat;
  var mglng = lng + dlng;

  return [lng * 2 - mglng, lat * 2 - mglat]

},
/**
 *
 * @param {*} lng
 * @param {*} lat
 * @return {lng,lat}
 */
wgs84_to_gcj02(lng, lat) {
    var PI = 3.1415926535897932384626;
    var a = 6378245.0; //卫星椭球坐标投影到平面地图坐标系的投影因子。
    var ee = 0.00669342162296594323; //椭球的偏心率。

    function transformlat(lng, lat) {
        var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
        ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
        ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
        return ret
    }

    function transformlng(lng, lat) {
        var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
        ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
        ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
        return ret
    }

    /**
     * 判断是否在国内，不在国内则不做偏移
     * @param lng
     * @param lat
     * @returns {boolean}
     */
    function out_of_china(lng, lat) {
        return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false);
    }
    if (out_of_china(lng, lat)) {
        return [lng, lat]
    } else {
        var dlat = transformlat(lng - 105.0, lat - 35.0);
        var dlng = transformlng(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        return [mglng, mglat]
    }
  },

}

export {
  oAppletEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/applet.js